import React from "react";
import { Modal, Button } from "react-bootstrap";

const FilePreviewModal = ({ show, onHide, previewUrl, contentType }) => {
  const isImage = contentType?.startsWith("image/");
  // const isPdf = contentType?.includes("pdf");

  return (
    <Modal show={show} onHide={onHide} centered size="md">
      <Modal.Header closeButton>
        <Modal.Title></Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {previewUrl ? (
          isImage ? (
            <img
              src={previewUrl}
              alt="이미지 미리보기"
              style={{ width: "100%", height: "auto" }}
            />
          ) : (
            <iframe
              src={previewUrl}
              title="파일 미리보기"
              style={{ width: "100%", height: "70vh", border: "none" }}
            />
          )
        ) : (
          <div>파일이 없습니다.</div>
        )}
      </Modal.Body>

      {/* <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          닫기
        </Button>
      </Modal.Footer> */}
    </Modal>
  );
};

export default FilePreviewModal;
